import React from 'react';

import {useViewBarContext} from '../../NamedWorkspaceViewBarContext';
import {DeleteViewModalContent} from './DeleteViewModalContent';
import {SaveViewModalContent} from './SaveViewModalContent';

export const NamedWorkspaceModalContent = () => {
  const {modalDetails} = useViewBarContext();

  if (modalDetails == null) {
    return null;
  }

  const {type: modalType} = modalDetails;

  if (modalType === 'delete view') {
    return <DeleteViewModalContent />;
  }

  if (modalType === 'save view') {
    return <SaveViewModalContent />;
  }

  return null;
};
